import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { navLinks, legalLinks, restaurant, fullAddress } from "../../data/siteData";
import { useHours } from "../../lib/content";
import { summarizeHours } from "../../lib/hours";

export const Footer = () => {
  const hours = summarizeHours(useHours());
  return (
  <footer className="relative border-t border-[#D4A359]/20 bg-[#081A10] pt-20 pb-10 overflow-hidden" data-testid="site-footer">
    <div className="container-site">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <LogoMark className="w-14 h-14" />
          <p className="mt-6 font-display text-3xl sm:text-4xl text-[#F7F4EB]">CAP SUD</p>
          <p className="mt-2 text-sm text-[#D6CFC0]">{restaurant.tagline} à Morangis · depuis {restaurant.since}</p>
          <p className="mt-6 text-[#D6CFC0]" data-testid="footer-address">{fullAddress}</p>
          <a href={restaurant.phoneHref} className="mt-2 inline-block text-lg text-[#E5B66C] hover:text-[#F7F4EB] transition-colors" data-testid="footer-phone">
            {restaurant.phone}
          </a>
        </div>
        <div className="lg:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4A359]">Navigation</p>
          <ul className="mt-5 space-y-2.5">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-[#D6CFC0] hover:text-[#F7F4EB] transition-colors" data-testid={`footer-link-${l.id}`}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4A359]">Informations légales</p>
          <ul className="mt-5 space-y-2.5">
            {legalLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-[#D6CFC0] hover:text-[#F7F4EB] transition-colors" data-testid={`footer-legal-${l.id}`}>{l.label}</Link>
              </li>
            ))}
          </ul>
          <ul className="mt-8 space-y-1 text-sm text-[#A2B3A7]" data-testid="footer-hours">
            {hours.map((h) => <li key={h.days}>{h.days} : {h.text}</li>)}
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="mt-16 font-display text-[22vw] lg:text-[15rem] leading-[0.8] text-[#F7F4EB]/[0.04] select-none whitespace-nowrap">Cap Sud</p>
      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-3 border-t border-[#D4A359]/10 pt-6 text-xs text-[#A2B3A7]">
        <p>© {new Date().getFullYear()} CAP SUD — Tous droits réservés.</p>
        <p>Restaurant & pizzeria · Morangis (91)</p>
      </div>
    </div>
  </footer>
  );
};
